import Axios from "../../api/Axios";
const BASE_URL = "StockNormBulkUpload/";

export const EndpointStockNormBulkUpload = {
    GetDateRange: "GetDateRange",
    PopulateQuarter: "PopulateQuarter",
    UploadCSV: "UploadCSV"
};

export const createAPIEndpointStockNormBulkUpload = () => {
    return { 
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint,data)=> Axios.post(BASE_URL+Endpoint,data)
    };
};